<template>
  <div class="overflow-auto h-100">
    <div class="item-list" v-if="hasItems">
      <list-item
          v-for="item in items"
          :row="item"
          :key="item.model.id"
          class="item-list__item"
          :class="{'item-list__item_current': isCurrent(item)}"
          @select="onSelect"
          @toggle="onToggle"
      ></list-item>
    </div>
    <div v-else-if="!isRequestActive" class="h-100 d-flex align-items-center justify-content-center text-muted-light font-weight-bold">
      Empty
    </div>
    <div v-else class="h-100 d-flex align-items-center justify-content-center">
      <i class="fas fa-sync-alt fa-spin"></i>
    </div>
  </div>

</template>

<script>
import List from '../../../secutity-group/simple-list';
import ListItem from './group-list-item';
import eventBus from '../../../../event-bus';

export default {
  extends: List,

  components: {
    ListItem,
  },

  data() {
    return {
      userId: null,
    };
  },

  methods: {
    /**
     * @param {object} item
     */
    onSelect(item) {
      this.current = item;
    },

    /**
     * @param {object} value
     */
    onToggle({url, id}) {
      const form = {
        user_id: this.userId,
        group_id: id,
      };

      const index = _.findIndex(this.items, item => item.model.id === id);
      const item = _.get(this.items, [index]);
      this.items.splice(index, 1, _.assign({}, item, {is_bound: !item.is_bound}));

      return axios.post(url, form)
          .then(({data: {message, meta: {permissions}}}) => {
            _.isString(message) && this.$message.success(message);
            this.updatePermissions(permissions);
          })
          .catch(err => {
            this.items.splice(index, 1, item);
            this.handleErrorResponse(err);
          });
    },

    /**
     * @param {Object} data
     * @return {Boolean}
     */
    onLoadSuccess({data: {data: items, meta: {user_id, permissions}}}) {
      this.items.push(...items);
      this.userId = user_id;
      this.updatePermissions(permissions);

      return false;
    },

    /**
     * @param {Array} permissions
     */
    updatePermissions(permissions) {
      this.$nextTick(function () {
        eventBus.$emit('permission-list-change', {permissions});
      });
    },
  },
}
</script>
